<template>
  <div class="form_wrap">
    <vxe-modal
      v-model="formConfig.show"
      @hide="hideModel"
      @show="showHandle"
      :fullscreen="false"
      :id="formConfig.id"
      :width="formConfig.modelConfig?formConfig.modelConfig.width:1200"
      :height="formConfig.modelConfig?formConfig.modelConfig.height:800"
      :min-width="formConfig.modelConfig?formConfig.modelConfig.minWidth:800"
      :min-height="formConfig.modelConfig?formConfig.modelConfig.minHeight:600"
      show-zoom
      resize
      storage
      show-footer
      :transfer="true"
      :zIndex="1020"
      :destroy-on-close="true"
    >
      <template #title>
        <span>{{formConfig.title}}</span>
      </template>
      <template #default>
        <div class="form_content_wrap">
          <div class="form" v-loading="loading">
            <!-- 无从表 -->
            <div
              v-if="!item.hidden&&!item.hasChildren"
              class="form_item"
              v-for="(item, index) in formConfig.form"
              :key="index"
            >
              <div class="lab" :class="{'required':item.required}">{{item.label}}：</div>
              <div class="con" v-if="formConfig.type!='R'">
                <el-input
                  size="mini"
                  v-if="item.kjlx=='input'"
                  v-model="item.value"
                  :placeholder="'请输入'+item.label"
                  @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                ></el-input>
                <el-input
                  size="mini"
                  v-if="item.kjlx=='number'"
                  type="number"
                  v-model="item.value"
                  :placeholder="'请输入'+item.label"
                  @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                ></el-input>
                <el-date-picker
                  v-if="item.kjlx=='date'"
                  v-model="item.value"
                  type="date"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  class="my_form"
                  placeholder="选择日期"
                  @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                ></el-date-picker>
                <el-date-picker
                  v-if="item.kjlx=='datetime'"
                  v-model="item.value"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="mini"
                  class="my_form"
                  placeholder="选择日期"
                  @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                ></el-date-picker>
                <el-radio-group v-model="item.value" v-if="item.kjlx=='radio'">
                  <el-radio
                    :label="item2.value"
                    v-for="(item2, index2) in item.list"
                    @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                    :key="index2"
                  >{{item2.label}}</el-radio>
                </el-radio-group>
                <el-select
                  size="mini"
                  v-if="item.kjlx=='select'"
                  v-model="item.value"
                  :placeholder="'请选择'+item.label"
                  class="my_form"
                  @change="item.changeFun?item.changeFun(item,formConfig.form):null"
                >
                  <el-option
                    v-for="(item2, index2) in item.list"
                    :key="index2"
                    :value="item2.value"
                    :label="item2.label"
                  ></el-option>
                </el-select>
                <div class="fj" v-if="item.kjlx=='file'">
                  <el-input size="mini" v-model="item.value" disabled :placeholder="item.label"></el-input>
                  <el-button-group class="upload">
                    <el-button
                      @click="upload(item)"
                      v-if="formConfig.type!='R'"
                      type="primary"
                      size="mini"
                      icon="el-icon-upload"
                    ></el-button>
                    <el-button @click="viewFile(item)" type="primary" size="mini" icon="el-icon-view"></el-button>
                  </el-button-group>
                </div>
              </div>
              <div class="con" v-else>
                <div class="fj" v-if="item.kjlx=='file'">
                  <el-input size="mini" v-model="item.value" disabled :placeholder="item.label"></el-input>
                  <el-button-group class="upload">
                    <el-button
                      @click="upload(item)"
                      v-if="formConfig.type!='R'"
                      type="primary"
                      size="mini"
                      icon="el-icon-upload"
                    ></el-button>
                    <el-button @click="viewFile(item)" type="primary" size="mini" icon="el-icon-view"></el-button>
                  </el-button-group>
                </div>
                <div v-else>{{item.format?item.format(item):item.value}}</div>
              </div>
            </div>
            <!-- 有从表 -->
            <div
              class="has_child_item"
              v-if="item.hasChildren"
              v-for="(item, index) in formConfig.form"
              :key="index"
            >
              <div class="has_child_item_title" :class="{'required':item.required}">
                {{item.label}}
                <el-button-group class="btn_group" v-if="formConfig.type!='R'">
                  <el-button type="primary" icon="el-icon-plus" @click="addItem(item)" size="mini"></el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-document-copy"
                    @click="copyItem(item)"
                    size="mini"
                  ></el-button>
                </el-button-group>
              </div>
              <div class="has_child_item_content" v-if="item.value.length">
                <el-tabs
                  type="card"
                  v-model="item.tabModel"
                  :closable="formConfig.type!='R'"
                  @tab-remove="removeTab($event,item.value,item)"
                  @tab-click="tabClickHandle($event,item)"
                >
                  <el-tab-pane
                    v-for="(item2, index2) in item.value"
                    :key="index2"
                    :label="item.label+(index2+1)"
                    :name="index2+''"
                  >
                    <div class="form form_2_level">
                      <div class="tools">
                        <el-button
                          type="primary"
                          round
                          v-if="item.helpButton&& formConfig.type!='R'"
                          @click="item.helpButton.helpFunc(item2)"
                          size="mini"
                        >{{item.helpButton.label}}</el-button>
                      </div>
                      <div
                        v-if="!item3.hidden&&!item3.hasChildren"
                        class="form_item"
                        v-for="(item3, index3) in item.config"
                        :key="index3"
                      >
                        <div class="lab" :class="{'required':item3.required}">{{item3.label}}：</div>
                        <div class="con" v-if="formConfig.type!='R'">
                          <el-input
                            size="mini"
                            v-if="item3.kjlx=='input'"
                            v-model="item2[index3]"
                            :placeholder="'请输入'+item3.label"
                          ></el-input>
                          <el-input
                            size="mini"
                            v-if="item3.kjlx=='number'"
                            type="number"
                            v-model="item2[index3]"
                            :placeholder="'请输入'+item3.label"
                          ></el-input>
                          <el-select
                            size="mini"
                            v-if="item3.kjlx=='select'"
                            v-model="item2[index3]"
                            :placeholder="'请选择'+item3.label"
                            class="my_form"
                          >
                            <el-option
                              v-for="(item4, index4) in item3.list"
                              :key="index4"
                              :value="item4.value"
                              :label="item4.label"
                            ></el-option>
                          </el-select>
                          <el-date-picker
                            v-if="item3.kjlx=='date'"
                            v-model="item2[index3]"
                            type="date"
                            value-format="yyyy-MM-dd"
                            size="mini"
                            class="my_form"
                            placeholder="选择日期"
                          ></el-date-picker>
                          <el-radio-group v-model="item2[index3]" v-if="item3.kjlx=='radio'">
                            <el-radio
                              :label="item4.value"
                              v-for="(item4, index4) in item3.list"
                              :key="index4"
                            >{{item4.label}}</el-radio>
                          </el-radio-group>
                        </div>
                        <div class="con" v-else>{{item2[index3]}}</div>
                      </div>
                      <!-- 二级从表 -->
                      <div
                        class="has_child_item"
                        v-if="item3.hasChildren"
                        v-for="(item3, index3) in item.config"
                        :key="index3"
                      >
                        <div class="has_child_item_title" :class="{'required':item3.required}">
                          {{item3.label}}
                          <el-button-group class="btn_group" v-if="formConfig.type!='R'">
                            <el-button
                              type="primary"
                              icon="el-icon-plus"
                              @click="addItemChild(item3,item2[index3])"
                              size="mini"
                            ></el-button>
                            <el-button
                              type="primary"
                              icon="el-icon-document-copy"
                              @click="copyItemChild(item3,item2[index3])"
                              size="mini"
                            ></el-button>
                          </el-button-group>
                        </div>
                        <div class="has_child_item_content" v-if="item2[index3].length">
                          <el-tabs
                            type="card"
                            v-model="item3.tabModel"
                            :closable="formConfig.type!='R'"
                            @tab-remove="removeTab($event,item2[index3],item3)"
                          >
                            <el-tab-pane
                              v-for="(item4, index4) in item2[index3]"
                              :key="index4"
                              :label="item3.label+(index4+1)"
                              :name="index4+''"
                            >
                              <div class="form form_3_level">
                                <div class="tools">
                                  <el-button
                                    type="primary"
                                    round
                                    v-if="item3.helpButton&&formConfig.type!='R'"
                                    @click="item3.helpButton.helpFunc(item4)"
                                    size="mini"
                                  >{{item3.helpButton.label}}</el-button>
                                </div>
                                <div
                                  v-if="!item5.hidden"
                                  class="form_item"
                                  v-for="(item5, index5) in item3.config"
                                  :key="index5"
                                >
                                  <div
                                    class="lab"
                                    :class="{'required':item5.required}"
                                  >{{item5.label}}：</div>
                                  <div class="con" v-if="formConfig.type!='R'">
                                    <el-input
                                      size="mini"
                                      v-if="item5.kjlx=='input'"
                                      v-model="item4[index5]"
                                      :placeholder="'请输入'+item5.label"
                                    ></el-input>
                                    <el-input
                                      size="mini"
                                      v-if="item5.kjlx=='number'"
                                      type="number"
                                      v-model="item4[index5]"
                                      :placeholder="'请输入'+item5.label"
                                    ></el-input>
                                  </div>
                                  <div class="con" v-else>{{item4[index5]}}</div>
                                </div>
                              </div>
                            </el-tab-pane>
                          </el-tabs>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>

      </template>
      <template #footer>
        <vxe-button
          status="primary"
          v-if="formConfig.type!='R'"
          size="mini"
          @click="formConfig.save(formData)"
        >提交</vxe-button>
        <vxe-button size="mini" status="primary" v-if="formConfig.type!='R'" @click="reset">重置</vxe-button>
        <vxe-button size="mini" @click="formConfig.show=false">取消</vxe-button>
      </template>
    </vxe-modal>
    <common-upload :uploadConfig="uploadConfig"></common-upload>
  </div>
</template>

<script>
import CommonUpload from "@/components/CommonUpload/index";

export default {
  components: {
    CommonUpload
  },
  props: {
    formConfig: {
      type: Object,
      required: true,
      default: {},
      d: {}
    }
  },
  name: "CommonFormCurdVue",
  methods: {
    upload(item) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "edit";
      this.uploadConfig.files = item.value;

      this.tmpChosenData = item;
    },
    viewFile(item) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "view";
      this.uploadConfig.files = item.value;
      this.tmpChosenData = item;
    },
    tabClickHandle(e, item) {
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          item.config[i].tabModel = "0";
        }
      }
    },
    removeTab(name, arr, item) {
      var n = parseInt(name);
      this.$confirm("将删除此条目，是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          item.tabModel = "0";
          arr.splice(n, 1);
        })
        .catch(() => {});
    },
    copyItem(item) {
      if (item.value.length) {
        var n = parseInt(item.tabModel);
        item.value.push(item.value[n]);
      } else {
        this.$message.warning("无条目可复制");
      }
    },
    copyItemChild(item, value) {
      if (value.length) {
        var n = parseInt(item.tabModel);
        value.push(value[n]);
      } else {
        this.$message.warning("无条目可复制");
      }
    },
    addItemChild(item, value) {
      var obj = {};
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          obj[i] = [];
        } else {
          obj[i] = null;
        }
      }
      value.push(obj);
    },
    addItem(item) {
      var obj = {};
      for (var i in item.config) {
        if (item.config[i].hasChildren) {
          obj[i] = [];
        } else {
          obj[i] = null;
        }
      }
      item.value.push(obj);
      console.log(item.value);
      console.log(JSON.parse(JSON.stringify(item.value)));
    },
    showHandle() {
      if (this.formConfig.type != "C") {
        this.loading = true;
        this.getData();
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    async getData() {
      let res = await this.$d[this.formConfig.getDetailUrl](
        this.formConfig.params
      );
      if (res.success) {
        var d = res.data;
        this.d = d;
        var f = this.formConfig.form;
        for (var i in f) {
          f[i]["value"] = d[i];
        }
        console.log(f);
      } else {
        this.$message.warning(res.msg);
      }
    },
    reset() {
      var f = this.formConfig.form;
      this.formConfig.params = {};
      for (var i in f) {
        if (f[i]["value"] instanceof Array) {
          f[i]["value"] = [];
        } else {
          f[i]["value"] = null;
        }
      }
    },
    hideModel() {
      this.reset();
    }
  },
  computed: {
    formData() {
      var f = {};
      var mustin = [];
      var d = this.formConfig.form;
      console.log(d);
      for (var i in d) {
        if (d[i].hasChildren) {
          if (d[i].required && !d[i]["value"].length) {
            mustin.push(d[i].label);
          }
        } else {
          if (d[i].required && !d[i]["value"]) {
            mustin.push(d[i].label);
          }
        }
        f[i] = d[i]["value"];
      }
      if (mustin.length) {
        return {
          valid: false,
          data: mustin.join("，") + "不能为空"
        };
      } else {
        return {
          valid: true,
          data: f
        };
      }
    }
  },
  data() {
    return {
      tmpChosenData: {},
      loading: false,
      uploadConfig: {
        type: "",
        show: false,
        files: "",
        id: "common_upload",
        title: "上传附件",
        save: res => {
          this.tmpChosenData.value = res;
          this.uploadConfig.show = false;
        }
      }
    };
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.form_content_wrap{
    height: 100%;
    background: #ffffff;
    border: 1px solid #cccccc;
    overflow: auto;
    padding: 5px 10px 15px;
    border-radius: 5px;
    box-shadow: 0 0px 8px 0 rgba(7, 17, 27, 0.2);

}
.form {
    // border: 1px solid #cccccc;
    // height: 100%;
    // overflow: auto;
    background: #ffffff;
    padding: 5px 10px 15px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    // box-shadow: 0 0px 8px 0 rgba(7, 17, 27, 0.2);
    .form_item {
        display: flex;
        width: 50%;
        padding: 0 30px;
        align-items: center;
        height: 60px;
        // border:1px solid red;
        .lab {
            flex: 0 0 160px;
            font-weight: bold;
            color: #409eff;
        }
        .con {
            flex: 1;
            overflow: hidden;
        }
    }
    .has_child_item {
        width: 100%;
        padding: 0 20px;
        .has_child_item_title {
            color: #409eff;
            font-weight: 700;
            font-size: 17px;
            padding: 10px;
            border: 1px solid #409eff;
            border-left: 5px solid #409eff;
            border-radius: 0 5px 5px 0;
            margin: 10px 0 20px;
            background: #fff;
            box-shadow: 0 0 12px 0 rgba(135, 214, 238, 0.2);
            .btn_group {
                margin-left: 20px;
            }
        }
    }
}
.form_2_level {
    background: #f0f7fd;
}
.form_3_level {
    background: #dff0fa;
}
.required::before {
    content: "* ";
    color: red;
}
.el-tabs {
    background: #ffffff;
}
.my_form {
    width: 100%;
}
.tools {
    width: 100%;
}
.fj {
    display: flex;
    align-items: center;
    .upload {
        margin-left: 5px;
        // flex: 0 0 100px;
        display: flex;
    }
}
</style>
